import { CardAction, CardHeader, CardTitle } from '@azelis/ui/components/card';
import { Info } from 'lucide-react';

interface QuestionHeaderProps {
  number: string;
  text: string;
  hoverDetails: string;
}

/** Question number/text plus an info icon that surfaces thinking/citation on hover, tucked
 * into the Card's own top-right corner via CardAction. */
export function QuestionHeader({ number, text, hoverDetails }: QuestionHeaderProps) {
  return (
    <CardHeader>
      <CardTitle className="text-sm font-medium">
        {number ? `${number}. ` : ''}
        {text}
      </CardTitle>
      {hoverDetails && (
        <CardAction>
          <span
            title={hoverDetails}
            className="cursor-help text-muted-foreground">
            <Info className="size-4" />
          </span>
        </CardAction>
      )}
    </CardHeader>
  );
}
